import { render, staticRenderFns } from "./deliverInfo.vue?vue&type=template&id=267cf898"
import script from "./deliverInfo.vue?vue&type=script&lang=js"
export * from "./deliverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports